export default __webpack_public_path__ + "img/bg-404-mobile.jpg?f63e";